import { FormSectionHandler } from '../entity.handler';
import { AnalyticsBaseReportResponse } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField } from '../utils';
import { ICONS } from '../icons';

interface EditorValues extends AnalyticsBaseReportResponse {
    name: string;
}

export class AnalyticsBaseReportSectionHandler implements FormSectionHandler<AnalyticsBaseReportResponse, EditorValues> {

    type = 'form';
    icon = ICONS.dashboard;
    bulk = true;
    readonly = true;
    actions = [

    ];

    title = this.translate('DETAILS.TITLE');
    description = this.translate('DETAILS.DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ANALYTICSBASEREPORT.${key}`, values);
    }

    applyUpdate(_entity: AnalyticsBaseReportResponse, _payload: any): Promise<AnalyticsBaseReportResponse> {
        throw new Error('Not Supported');
    }

    async mapEntityToEditor(entity: AnalyticsBaseReportResponse): Promise<EditorValues> {
        if (entity.status === 'failed' && entity.mode === 'repeat') {
            this.actions.push({ id: 'rebuild', name: this.translate('ACTIONS.REBUILD'), showAlways: true });
        }
        return {
            ...entity,
        };
    }

    mapEditorToEntity(_entity: AnalyticsBaseReportResponse, _values: EditorValues): Promise<any> {
        throw new Error('Not Supported');
    }

    async getFields(_entity: AnalyticsBaseReportResponse): Promise<FormBuilderField[]> {
        return [
            TextField('name', this.translate('COLUMNS.NAME'), true, 1, 255),
            TextField('title', this.translate('COLUMNS.TITLE'), false, 1, 255),
            TextField('user.name', this.translate('COLUMNS.USER'), false, 1, 255),
            TextField('taskId', this.translate('COLUMNS.TASK_ID'), false, 1, 255),
            TextField('mode', this.translate('COLUMNS.MODE'), false, 1, 255),
            TextField('status', this.translate('COLUMNS.STATUS'), false, 1, 255),
            TextField('priority', this.translate('COLUMNS.PRIORITY'), false, 1, 255),
            TextField('progress', this.translate('COLUMNS.PROGRESS'), false, 1, 255),
            TextField('totalTasks', this.translate('COLUMNS.TASKS_TOTAL'), false, 1, 255),
            TextField('completedTasks', this.translate('COLUMNS.TASKS_COMPLETED'), false, 1, 255),
            TextField('firstPassComplete', this.translate('COLUMNS.FIRST_PASS_COMPLETE'), false, 1, 255),
            TextField('lastCompletedDate', this.translate('COLUMNS.LAST_RUN_DATE'), false, 1, 255),
            TextField('runEndDate', this.translate('COLUMNS.END_DATE'), false, 1, 255),
            TextField('date', this.translate('COLUMNS.DATE'), false, 1, 255),
        ].filter(x => x);
    }


    async actionTriggered(entity: AnalyticsBaseReportResponse, action: string): Promise<void> {
        try {
            if (action === 'rebuild') {
                await this.admin.applyUpdate(api => api.reports.rebuildAnalyticsBaseReport(entity.id));
                await this.admin.modal.alert('Base report has been successfully rebuilt.');
            }
        } catch (err) {
            this.admin.modal.error('Base report rebuild failed.', err);
        }
    }


}
